export enum FloorExceptionalClosingHoursStaleTimeEnum {
  GetFloorExceptionalClosingHours = 60000,
  GetFloorExceptionalClosingHoursByFloorId = 60000,
}
